export default __webpack_public_path__ + "static/media/wiapy.74b6a64c.png";